import { useEffect } from 'react';
import { initializeTemplate } from '../utils/scriptLoader';

const useTemplateScripts = () => {
    useEffect(() => {
        const init = async () => {
            try {
                console.log('[Template] Initializing template scripts...');

                // Esperar a que React termine de renderizar
                await new Promise(resolve => setTimeout(resolve, 300));

                // Cargar scripts del template
                await initializeTemplate();

                console.log('[Template] Template initialized successfully');

                // Hacer click en el elemento #to-top cuando todo esté cargado
                setTimeout(() => {
                    const toTopElement = document.getElementById('to-top');
                    if (toTopElement) {
                        toTopElement.click();
                    }
                }, 100);

            } catch (error) {
                console.error('[Template] Error initializing template:', error);
                // Intentar reinicializar una vez más después de un tiempo
                setTimeout(() => {
                    console.log('[Template] Retrying initialization...');
                    initializeTemplate().catch(err => {
                        console.error('[Template] Retry failed:', err);
                    });
                }, 1000);
            }
        };

        init();

        // Cleanup function
        return () => {
            // Limpiar efectos si es necesario
            const typedElements = document.querySelectorAll('.typed-cursor');
            typedElements.forEach(element => element.remove());

            // Limpiar instancias de Lenis si existen
            if (window.lenisInstance) {
                window.lenisInstance.destroy();
            }

            // Limpiar clases del body si el menú estaba abierto
            document.body.classList.remove('menu-open');
            document.body.style.overflow = '';

            // Limpiar clase del header
            const header = document.querySelector('.mxd-header');
            if (header) {
                header.classList.remove('menu-is-visible');
            }
        };
    }, []);
};

export default useTemplateScripts;